'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _saveItem = require('./remote/saveItem');

var SaveItem = {
    fetchSavedItemCounts: function fetchSavedItemCounts(params) {
        return _saveItem.SaveItemRemote.fetchSavedItemCounts(params);
    },
    postSaveItem: function postSaveItem(params) {
        return _saveItem.SaveItemRemote.postSaveItem(params);
    },
    postUnsaveItem: function postUnsaveItem(params) {
        return _saveItem.SaveItemRemote.postUnsaveItem(params);
    }
};

exports.default = SaveItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/saveItem.js
// module id = wUUL
// module chunks = 46